import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { FiX, FiRotateCcw } from 'react-icons/fi';
import { Button } from './common';

const SignaturePad = ({ onSave, onClear, initialSignature = null, disabled = false }) => {
  const sigPadRef = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);
  const [hasSigned, setHasSigned] = useState(!!initialSignature);
  const [showCanvas, setShowCanvas] = useState(!initialSignature);

  const handleClear = () => {
    if (sigPadRef.current) {
      sigPadRef.current.clear();
    }
    setIsEmpty(true);
    setShowCanvas(true);
    if (onClear) {
      onClear();
    }
  };

  const handleSave = () => {
    if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
      const dataURL = sigPadRef.current.toDataURL('image/png');
      setIsEmpty(false);
      if (onSave) {
        onSave(dataURL);
      }
    }
  };

  const handleBegin = () => {
    setIsEmpty(false);
  };

  const handleEnd = () => {
    if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
      setIsEmpty(false);
      setHasSigned(true);
      const dataURL = sigPadRef.current.toDataURL('image/png');
      if (onSave) {
        onSave(dataURL);
      }
    }
  };

  return (
    <div className="w-full">
      <div className="border-2 border-gray-300 rounded-lg bg-white p-2" style={{ position: 'relative' }}>
        {initialSignature && !showCanvas ? (
          <div className="relative">
            <img
              src={initialSignature}
              alt="Signature"
              className="w-full h-48 object-contain rounded"
            />
            {!disabled && (
              <Button
                variant="outline"
                size="sm"
                onClick={handleClear}
                className="absolute top-2 right-2"
              >
                <FiRotateCcw className="mr-1" />
                Re-sign
              </Button>
            )}
          </div>
        ) : (
          <>
            <SignatureCanvas
              ref={sigPadRef}
              canvasProps={{
                className: 'signature-canvas w-full h-48',
                style: { touchAction: 'none' }
              }}
              onBegin={handleBegin}
              onEnd={handleEnd}
              backgroundColor="#ffffff"
              penColor="#000000"
            />
            {!disabled && !isEmpty && (
              <div className="flex gap-2 mt-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={handleClear}
                >
                  <FiRotateCcw className="mr-1" />
                  {hasSigned ? 'Re-sign' : 'Clear'}
                </Button>
              </div>
            )}
          </>
        )}
      </div>
      <p className="mt-2 text-xs text-gray-500">
        {disabled 
          ? 'Signature captured' 
          : (initialSignature && !showCanvas)
            ? 'Click "Re-sign" to change your signature' 
            : 'Please sign above using your mouse or touch screen'}
      </p>
    </div>
  );
};

export default SignaturePad;
